export const sexos = [
    { label: "Masculino", value: "Masculino" },
    { label: "Femenino", value: "Femenino" },
];